import React from 'react'
import {
  Stack,
  Table,
  Tbody,
  Tr,
  Td,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box
} from '@chakra-ui/react'
import { startCase } from 'lodash'
import { PortfolioHomeFeatures } from '@homevest/types/homes'
import { formatMoney } from 'lib/numbers'

interface FeaturesGridProps {
  portfolioHomeFeatures: PortfolioHomeFeatures
}

const FeaturesGrid: React.FC<FeaturesGridProps> = ({ portfolioHomeFeatures }) => {
  return (
    <Stack direction='column' gap='2'>
      <Accordion allowMultiple>
        {Object.entries(portfolioHomeFeatures)
          .filter(([_, featureList]) => Object.values(featureList).some((value) => value))
          .map(([category, featureList]) => (
            <AccordionItem key={category}>
              <AccordionButton>
                <Box flex='1' textAlign='left' fontWeight='bold'>
                  {startCase(category)}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                <Table variant='simple' size='sm'>
                  <Tbody>
                    {Object.entries(featureList).map(([feature, value]) => (
                      <Tr
                        key={`${category}-${feature}`}
                        _hover={{ bg: 'gray.50' }}
                        transition='background-color 0.2s'
                      >
                        <Td fontWeight='bold' width='35%'>
                          {startCase(feature)}
                        </Td>
                        <Td width='65%'>
                          {typeof value === 'boolean'
                            ? value
                              ? 'Yes'
                              : 'No'
                            : feature === 'amenityFee'
                            ? formatMoney(Number(value ?? undefined), 2, '$')
                            : feature === 'security'
                            ? startCase(String(value ?? ''))
                            : value}
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </AccordionPanel>
            </AccordionItem>
          ))}
      </Accordion>
    </Stack>
  )
}

export default FeaturesGrid
